//Contact Module const
export const FETCH_START = "fetch_start";
export const FETCH_SUCCESS = "fetch_success";
export const FETCH_ERROR = "fetch_error";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const HIDE_MESSAGE = "HIDE_MESSAGE";
export const ON_SHOW_LOADER = "ON_SHOW_LOADER";
export const ON_HIDE_LOADER = "ON_HIDE_LOADER";
export const INIT_URL = "INIT_URL";
export const SET_SOCKET = "SET_SOCKET";
export const RESET_STORE  = "RESET_STORE ";

//template functions
export const FETCH_TEMPLATES = "FETCH_TEMPLATES";
export const FETCH_STD_COMPS = "FETCH_STANDARD_COMPS";
export const FETCH_PRV_COMPS = "FETCH_PREVIOUS_COMPS";
export const SAVE_TEMPLATE = "SAVE_TEMPLATE";
export const FETCH_TEMPLATES_ERR = "FETCH_TEMPLATES_ERR";
export const FETCH_TEMPLATE = "FETCH_TEMPLATE";
export const DISABLE_TEMPLATES = "DISABLE_TEMPLATES";
export const PUBLISH_TEMPLATES = "PUBLISH_TEMPLATES";
export const DELETE_TEMPLATES = "DELETE_TEMPLATES";

// Create Template Action types

export const FETCH_ALL_TEMPLATE_TYPES = "FETCH_ALL_TEMPLATE_TYPES";
export const INIT_CANVAS = "INIT_CANVAS";
export const REPLACE_EDIT_CANVAS = "REPLACE_EDIT_CANVAS";
export const ADD_SECTION = "ADD_SECTION";
export const REMOVE_SECTION = "REMOVE_SECTION";
export const ADD_FIELD = "ADD_FIELD";
export const REMOVE_FIELD = "REMOVE_FIELD";
export const SET_EDIT_FIELD = "SET_EDIT_FIELD";
export const REMOVE_EDIT_FIELD = "REMOVE_EDIT_FIELD";
export const EDIT_FIELD = "EDIT_FIELD";
export const SELECT_TEMPLATE = "SELECT_TEMPLATE";
export const SELECT_SUB_TEMPLATE = "SELECT_SUB_TEMPLATE";
export const SET_ADDRESS_BOOK_FIELD = "SET_ADDRESS_BOOK_FIELD"

export const TEMPLATED_CREATEDBY = "TEMPLATED_CREATEDBY";
export const FETCH_TEMPLATES_TYPE = "FETCH_TEMPLATES_TYPE";
export const TEMPLATE_STATUS = "TEMPLATE_STATUS";
export const FETCH_STATUS_TYPE = "FETCH_STATUS_TYPE";
export const FETCH_USERS = "FETCH_USERS";
export const FETCH_STATUS_COUNT = "FETCH_STATUS_COUNT";
export const FETCH_REGEX_LIST = "FETCH_REGEX_LIST";
export const FETCH_ACTIVITY_LOGS_TABLE_DATA = "FETCH_ACTIVITY_LOGS_TABLE_DATA";

// For ASN
export const FETCH_SUPPLIER_MASTER_TEMPLATES = "FETCH_SUPPLIER_MASTER_TEMPLATES";
export const FETCH_CUSTOMER_MASTER_TEMPLATES = "FETCH_CUSTOMER_MASTER_TEMPLATES";
export const FETCH_ITEM_MASTER_TEMPLATES = "FETCH_ITEM_MASTER_TEMPLATES";
export const SELECT_ITEM_MASTER = "SELECT_ITEM_MASTER";
export const FETCH_ASN_INVOICE_CONFIG = "FETCH_ASN_INVOICE_CONFIG";
export const GENERATE_ASN_INVOICE = "GENERATE_ASN_INVOICE";

export const VEHICLE_ENTRY_DATA_LIST = "VEHICLE_ENTRY_DATA_LIST";//make all caps

//template actions
export const TEMPLATE_EDIT = "TEMPLATE_EDIT";
export const TEMPLATE_REMOVE = "TEMPLATE_REMOVE";

//data entry
export const DATA_ENTRY_FILTER = "DATA_ENTRY_FILTER";
export const DATA_ENTRY_COMPANY = "DATA_ENTRY_COMPANY";
export const DATA_ENTRY_FLOOR = "DATA_ENTRY_FLOOR";
export const FETCH_WAREHOUSES = "FETCH_WAREHOUSES";
export const FETCH_FLOORS = "FETCH_FLOORS";
export const FETCH_MAPPING = "FETCH_MAPPING";

// UI related
export const DRAWER_OPEN = "DRAWER_OPEN";
export const DRAWER_CLOSE = "DRAWER_CLOSE";
export const GRID_HEATMAP_OPEN_CLOSE = "GRID_HEATMAP_OPEN_CLOSE"

// Serial Number
export const GENERATE_UNIQUE_SERIAL_NUMBER = "GENERATE_UNIQUE_SERIAL_NUMBER"
// Inward Data Entry
export const SET_SELECTED_TEMPLATE = "SET_SELECTED_TEMPLATE";
export const FETCH_ITEM_MASTER_FOR_INWARD = "FETCH_ITEM_MASTER_FOR_INWARD";

// job
export const FETCH_ALL_JOBS = "FETCH_ALL_JOBS";
export const RESET_ALL_JOBS = "RESET_ALL_JOBS";
export const FETCH_JOB_DETAIL = "FETCH_JOB_DETAIL";
export const FETCH_CELL_RACK_LOCATION = "FETCH_CELL_RACK_LOCATION";
export const FETCH_WAREHOUSE_FLOORS = "FETCH_WAREHOUSE_FLOORS";
export const FETCH_TEMPLATE_HEADERS = "FETCH_TEMPLATE_HEADERS";
export const FETCH_JOB_TYPES = "FETCH_JOB_TYPES";
export const FETCH_JOB_TYPES_COUNT = "FETCH_JOB_TYPES_COUNT";
export const FETCH_ALL_WORKERS = "FETCH_ALL_WORKERS";
export const FETCH_SHIPMENTS = "FETCH_SHIPMENTS";
export const CREATE_GATE_IN_JOB = "CREATE_GATE_IN_JOB";
export const FETCH_ALL_JOB_ACTION = "FETCH_ALL_JOB_ACTION";
export const FETCH_ALL_JOBTYPE_ACTION_ID = "FETCH_ALL_JOBTYPE_ACTION_ID";
export const FETCH_JOB_STATUS_COUNT = "FETCH_JOB_STATUS_COUNT";
export const FETCH_JOB_TYPE_DETAILS = "FETCH_JOB_TYPE_DETAILS";
export const FETCH_JOB_LOCATION_DETAIL = "FETCH_JOB_LOCATION_DETAIL";
export const FETCH_JOB_PENDENCY_DETAIL = "FETCH_JOB_PENDENCY_DETAIL";
export const FETCH_JOB_PROCESS_CONFIG = "FETCH_JOB_PROCESS_CONFIG";
export const FETCH_WORK_ORDER_LIST_CONFIG = "FETCH_WORK_ORDER_LIST_CONFIG"
export const FETCH_JOB_SHIPMENT_DETAIL = "FETCH_JOB_SHIPMENT_DETAIL"
export const FETCH_SUGGESTION_LOCATION = "FETCH_SUGGESTION_LOCATION"
export const FETCH_JOB_LOCATION_GROUPVIEW_DATA = "FETCH_JOB_LOCATION_GROUPVIEW_DATA"
export const FETCH_ALL_JOB_SCANNING_LOGS_DATA = "FETCH_ALL_JOB_SCANNING_LOGS_DATA"
export const FETCH_JOB_USER_PERFOMANCE_SUMMARY = "FETCH_JOB_USER_PERFOMANCE_SUMMARY"
export const FETCH_JOB_TYPE_WISE_COUNT_DATA = "FETCH_JOB_TYPE_WISE_COUNT_DATA"
export const FETCH_JOB_LABEL_TEMPLATE_HEADERS = "FETCH_JOB_LABEL_TEMPLATE_HEADERS"
export const FETCH_JOB_LABEL_TEMPLATES_DATA = "FETCH_JOB_LABEL_TEMPLATES_DATA"
export const FETCH_OUTWARD_LABEL_SALES_DATA = "FETCH_OUTWARD_LABEL_SALES_DATA"
export const FETCH_OUTWARD_LABEL_SKU_DATA = "FETCH_OUTWARD_LABEL_SKU_DATA"
export const FETCH_OUTWARD_LABEL_INVENTORY_DATA = "FETCH_OUTWARD_LABEL_INVENTORY_DATA"
export const FETCH_JOB_LOCATION_SUGGESTIONS = "FETCH_JOB_LOCATION_SUGGESTIONS"
export const FETCH_JOB_ACTION_CONSTRAINTS = "FETCH_JOB_ACTION_CONSTRAINTS"

// Inventory
export const FETCH_ALL_INVENTORY = "FETCH_ALL_INVENTORY";
export const FETCH_INVENTORY_FOR_MODAL = "FETCH_INVENTORY_FOR_MODAL";
export const FETCH_INVENTORY_TYPE_COUNT = "FETCH_INVENTORY_TYPE_COUNT";
export const FETCH_INVENTORY_STATUS_COUNT = "FETCH_INVENTORY_STATUS_COUNT";
export const FETCH_SHIPMENT_DETAIL = "FETCH_SHIPMENT_DETAIL";
export const FETCH_PACKAGE_DETAIL = "FETCH_PACKAGE_DETAIL";
export const FETCH_VALIDATE_INVENTORY ="FETCH_VALIDATE_INVENTORY"
export const FETCH_LABEL_CONFIG_INVENTORY ="FETCH_LABEL_CONFIG_INVENTORY"
export const FETCH_JOB_CREATION = "FETCH_JOB_CREATION"
export const FETCH_ITEM_DETAIL = "FETCH_ITEM_DETAIL";
export const FETCH_PACKAGE_ITEM_DETAIL = "FETCH_PACKAGE_ITEM_DETAIL";
export const FETCH_TEMPLATE_HEADER = "FETCH_TEMPLATE_HEADER";
export const FETCH_INVENTORY_FOR_LABEL = "FETCH_INVENTORY_FOR_LABEL";
export const FETCH_ALL_TAGS = "FETCH_ALL_TAGS";
export const FETCH_USED_TAGS = "FETCH_USED_TAGS"
export const ALLOCATE_TAG = "FETCH_ALL_TAG";
export const DEALLOCATE_TAG = "FETCH_ALL_TAG";
export const FETCH_PARCEL_DIEMENSION_DATA = "FETCH_PARCEL_DIEMENSION_DATA"
export const FETCH_QC_LIST = "FETCH_QC_LIST"
export const FETCH_QC_STATUS_COUNT = "FETCH_QC_STATUS_COUNT"
export const FETCH_INV_KIT_PALLET_COMPONENTS = "FETCH_INV_KIT_PALLET_COMPONENTS"
export const FETCH_INVENTORY_LOCATIONS = "FETCH_INVENTORY_LOCATIONS"
export const FETCH_LABEL_PACKET_WISE_DETAIL = "FETCH_LABEL_PACKET_WISE_DETAIL"
export const FETCH_SHIPMENT_WISE_INVENTORY = "FETCH_SHIPMENT_WISE_INVENTORY"

//Notification Settings
export const FETCH_NOTIFICATIONS_SETTINGS_CONFIG_COMPS = "FETCH_NOTIFICATIONS_SETTINGS_CONFIG_COMPS"
export const FETCH_NOTIFICATIONS_SETTINGS_TABLE_DATA = "FETCH_NOTIFICATIONS_SETTINGS_TABLE_DATA"
export const FETCH_NOTIFICATION_SETTINGS_CONFIG_DETAIL = "FETCH_NOTIFICATION_SETTINGS_CONFIG_DETAIL"
export const FETCH_ALL_WEB_NOTIFICATIONS = "FETCH_ALL_WEB_NOTIFICATIONS"
export const FETCH_NOTIFICATION_STATUS_WISE_COUNT = "FETCH_NOTIFICATION_STATUS_WISE_COUNT"
export const FETCH_WEB_NOTIFICATIONS_UNREAD_COUNT = "FETCH_WEB_NOTIFICATIONS_UNREAD_COUNT"


//Report Module
export const FETCH_EXPLORE_REPORT_CONFIG_TABLE_DATA = "FETCH_EXPLORE_REPORT_CONFIG_TABLE_DATA"
export const FETCH_EXPLORE_REPORT_VIEW_CONFIG_DATA = "FETCH_EXPLORE_REPORT_VIEW_CONFIG_DATA"
export const FETCH_EXPLORE_REPORT_DYNAMIC_FILTERS = "FETCH_EXPLORE_REPORT_DYNAMIC_FILTERS"



// fetch inventory data
export const FETCH_INVENTORY_TABLE_HEADER = "FETCH_INVENTORY_TABLE_HEADER"
export const UPDATE_INVENTORY_TABLE_HEADER = "UPDATE_INVENTORY_TABLE_HEADER"
export const FETCH_INVENTORIES = "FETCH_INVENTORIES";
export const FETCH_INVENTORY = "FETCH_INVENTORY";
export const FETCH_INVENTORY_ERR = "FETCH_INVENTORY_ERR";

//inventory data filters
export const FETCH_INV_WAREHOUSE = "FTECH_INV_WAREHOUSE";
export const FETCH_INV_FLOOR = "FETCH_INV_FLOOR";
export const FETCH_INV_TIME = "FETCH_INV_TIME";
export const FETCH_INV_SHIPID = "FETCH_INV_SHIPID";
export const FETCH_INV_MAPPINGAREA = "FETCH_INV_MAPPINGAREA";
export const FETCH_INV_STATUS = "FETCH_INV_STATUS";
export const FETCH_INV_TYPESHIP = "FETCH_INV_TYPESHIP";
export const FETCH_INV_TYPEPACK = "FETCH_INV_TYPEPACK";
export const FETCH_INV_TYPEITEM = "FETCH_INV_TYPEITEM";
export const FETCH_PARCEL_DIEMENSION = "FETCH_PARCEL_DIEMENSION";

// inv filter for typeWise count
export const FETCH_INV_WAREHOUSE_COUNT = "FETCH_INV_WAREHOUSE_COUNT";
export const FETCH_INV_FLOOR_COUNT = "FETCH_INV_FLOOR_COUNT";

// Inventory Configuration
export const FETCH_INVENTORY_SETTINGS = "FETCH_INVENTORY_SETTINGS"
export const CHANGE_INVENTORY_SETTINGS = "CHANGE_INVENTORY_SETTINGS"

// Manage Controll Setting
export const FETCH_MANAGE_CONTROL_SETTINGS="FETCH_MANAGE_CONTROL_SETTINGS"
export const CHANGE_MANAGE_CONTROL_SETTING="CHANGE_MANAGE_CONTROL_SETTING"
// Table Header configuration
export const FETCH_TABLE_HEADER = "FETCH_TABLE_HEADER"
export const UPDATE_TABLE_HEADER = "UPDATE_TABLE_HEADER"


// main dashboard
export const GET_ALL_ANALYTICS = "GET_ALL_ANALYTICS";
export const GET_ZONE_USER = "GET_ZONE_USER";
export const TRACK_USER = "TRACK_USER";
export const GET_DASHBOARD_DATA="GET_CHART_DATA";
export const GET_WAREHOUSE_OPRATION="GET_WAREHOUSE_OPRATION"
export const  GET_WAREHOUSE_INVENTORY = "GET_WAREHOUSE_INVENTORY";
export const GET_REPORT = "GET_REPORT"
export const GET_HEADER = "GET_HEADER"
export const GET_ITEM_VISE_REPORT="GET_ITEM_VISE_REPORT"
export const GET_WAREHOUSE_OPRATION_COUNT_INSIGHTS="GET_WAREHOUSE_OPRATION_COUNT_INSIGHTS"
export const GET_WAREHOUSE_INVENTORY_INSIGHTS="GET_WAREHOUSE_INVENTORY_INSIGHTS"
// // inv for geeting template
// export const FETCH_TEMPLATE_HEADER = "FETCH_TEMPLATE_HEADER";



//template table
export const GET_TEMPLATE_FETCH = "GET_TEMPLATE_FETCH"
export const GET_TEMPLATE_SUCC = "GET_TEMPLATE_SUCC"
export const GET_TEMPLATE_ERR = "GET_TEMPLATE_ERR"

export const GET_ITEM_MASTER = "GET_ITEM_MASTER"
export const FETCH_ITEMS_DETAIL = "FETCH_ITEMS_DETAIL"
export const GET_PALLET_MASTER_CARD_COUNT = "GET_PALLET_MASTER_CARD_COUNT"

// Return Process
export const FETCH_STOCK_RETURN_LIST = "FETCH_STOCK_RETURN_LIST"
export const FETCH_STOCK_DATA = "FETCH_STOCK_DATA"
export const ADD_STOCK_RETURN = "ADD_STOCK_RETURN"



// Inventory Adjustments
export const FETCH_ADJUSTMENT_REASONS = "FETCH_ADJUSTMENT_REASONS";
export const CREATE_ADJUSTMENT_REASON = "CREATE_ADJUSTMENT_REASON";
export const FETCH_ALL_INVENTOR_ADJUSTMENTS = "FETCH_ALL_INVENTOR_ADJUSTMENTS";
export const FETCH_ADJUSTMENT_DETAILS = "FETCH_ADJUSTMENT_DETAILS";
export const CREATE_INVENTORY_ADJUSTMENT = "CREATE_INVENTORY_ADJUSTMENT";
export const FETCH_ADJUSTMENT_STATUS_COUNT = "FETCH_ADJUSTMENT_STATUS_COUNT"
export const FETCH_ADJUSTMENT_CARD_COUNT = "FETCH_ADJUSTMENT_CARD_COUNT"


// Advance shipment notice
export const FETCH_ADVANCE_NOTICE_SHIPMENT = "FETCH_ADVANCE_NOTICE_SHIPMENT"
export const EDIT_ADVANCE_NOTICE_SHIPMENT = "EDIT_ADVANCE_NOTICE_SHIPMNET"
export const VIEW_ADVANCE_NOTICE_SHIPMENT = "VIEW_ADVANCE_NOTICE_SHIPMENT"
export const REJECT_ADVANCE_NOTICE_SHIPMENT = "REJECT_ADVANCE_NOTICE_SHIPMENT"
export const FETCH_ASN_STATUS_COUNT = "FETCH_ASN_STATUS_COUNT"
export const FETCH_ASN_ACTION_TAGS = "FETCH_ASN_ACTION_TAGS"
export const FETCH_SUGGESTED_DOCK_LIST = "FETCH_SUGGESTED_DOCK_LIST"
export const FETCH_SUGGESTED_LOCATION = "FETCH_SUGGESTED_LOCATION"

// Sales Order Processing 
export const FETCH_SALES_ORDER_PROCESSING = "FETCH_SALES_ORDER_PROCESSING"
export const FETCH_SALES_DETAIL ="FETCH_SALES_DETAIL"
export const FETCH_SALES_STATUS_COUNT ="FETCH_SALES_STATUS_COUNT"
export const FETCH_SALES_ORDER_ITEM_LIST = "FETCH_SALES_ORDER_ITEM_LIST"
export const FETCH_ESOPFORM_TABLE_DATA = "FETCH_ESOPFORM_TABLE_DATA"
export const FETCH_PASSLINK_VALIDATION_TOKEN = "FETCH_PASSLINK_VALIDATION_TOKEN"
export const FETCH_ASSOCIATED_JOB = "FETCH_ASSOCIATED_JOB"
export const FETCH_ASSOCIATED_TRIP = "FETCH_ASSOCIATED_TRIP"
export const FETCH_AVAILABLE_SLOTS = "FETCH_AVAILABLE_SLOTS"
export const FETCH_SALES_ORDER_CARD_COUNT = "FETCH_SALES_ORDER_CARD_COUNT"
export const VALIDATE_SALES_CONSUMPTION = "VALIDATE_SALES_CONSUMPTION"
export const FETCH_SALES_ORDER_DISPATCH_PLANS = "FETCH_SALES_ORDER_DISPATCH_PLANS"


// Landing Form
export const FETCH_EXTERNAL_FORM_CONFIG = "FETCH_EXTERNAL_FORM_CONFIG"
export const FETCH_E_SALES_ORDER_PROCESSING = "FETCH_E_SALES_ORDER_PROCESSING"
export const FETCH_E_SALES_STATUS_COUNT = "FETCH_E_SALES_STATUS_COUNT"
export const FETCH_E_SALES_DETAIL = "FETCH_E_SALES_DETAIL"

// Dispatch Planning
export const FETCH_DISPATCH_PLANS_STATUS_COUNT = "FETCH_DISPATCH_PLANS_STATUS_COUNT"
export const FETCH_DISPATCH_PLANS_TABLE_DATA = "FETCH_DISPATCH_PLANS_TABLE_DATA"
export const FETCH_DISPATCH_PLANS_CARDWISE_COUNT = "FETCH_DISPATCH_PLANS_CARDWISE_COUNT"


// Entity Master
export const GET_MASTER_COUNT = "GET_MASTER_COUNT"

// KIt Master
export const FETCH_CONNECTED_SKU_DETAIL = "FETCH_CONNECTED_SKU_DETAIL"

//Route navigation
export const GET_NAVIGATION_ROUTE = "GET_NAVIGATION_ROUTE"

// Warehouse capacity
export const GET_WAREHOUSE_CAPACITY ="GET_WAREHOUSE_CAPACITY"

// Cell Capacity
export const GET_CELL_CAPACITy="GET_CELL_CAPACITY"
export const GET_CELL_STORAGE_CAPACITY ='GET_CELL_STORAGE_CAPACITY '
export const GET_CELL_CAPACITY_DETAIL ="GET_CELL_CAPACITY_DETAIL"
export const GET_UTILIZATION_ANALYTICS_BLOCK = "GET_UTILIZATION_ANALYTICS_BLOCK"
export const GET_UTILIZATION_ANALYTICS_RACK = "GET_UTILIZATION_ANALYTICS_RACK"

// Cell Accessbility
export const GET_CELL_ACCESSBILITY_LIST="GET_CELL_ACCESSBILITY_LIST"
export const GET_CELL_ACCESSBILITY_DETAIL ="GET_CELL_ACCESSBILITY_DETAIL"
export const FETCH_PTPW_HEATMAP_DATA ="FETCH_PTPW_HEATMAP_DATA"
export const FETCH_AREA_ACTIVITY_LOGS_DATA ="FETCH_AREA_ACTIVITY_LOGS_DATA"
export const FETCH_AREA_UTILIZATION_REPORT_DATA ="FETCH_AREA_UTILIZATION_REPORT_DATA"
export const FETCH_AREA_LOCATION_WISE_INSIGHTS_DATA ="FETCH_AREA_LOCATION_WISE_INSIGHTS_DATA"
export const FETCH_AREA_SKUWISE_OCCUPANCY_DATA ="FETCH_AREA_SKUWISE_OCCUPANCY_DATA"
export const FETCH_AREA_ACTIVITY_LOGS_STATUS_COUNT ="FETCH_AREA_ACTIVITY_LOGS_STATUS_COUNT"
export const SET_EXPORT_DATA_KEYS ="SET_EXPORT_DATA_KEYS"
export const SET_SKU_WISE_OCCUPANCY_TABLE_HEADERS ="SET_SKU_WISE_OCCUPANCY_TABLE_HEADERS"
export const FETCH_CAPACITY_DETAILS_TABLE_DATA ="FETCH_CAPACITY_DETAILS_TABLE_DATA"

// Cell Behaviour
export const GET_GRID_CELL_BEHAVIOUR_ANALYTICS ="GET_GRID_CELL_BEHAVIOUR_ANALYTICS"
export const GET_GRID_RACK_BEHAVIOUR_ANALYTICS ="GET_GRID_RACK_BEHAVIOUR_ANALYTICS"
export const GET_GRID_ALL_BEHAVIOUR_ANALYTICS ="GET_GRID_ALL_BEHAVIOUR_ANALYTICS"
export const GET_GRID_BEHAVIOUR_LIST ="GET_GRID_BEHAVIOUR_LIST"
export const GET_GRID_BEHAVIOUR_DETAIL ="GET_GRID_BEHAVIOUR_DETAIL"

// For ASN Entry
export const CLEAR_CONNECTED_MASTER_DETAIL = "CLEAR_CONNECTED_MASTER_DETAIL";
export const FETCH_SHIPMENT_CONNECTED_MASTER_DETAIL = "FETCH_SHIPMENT_CONNECTED_MASTER_DETAIL"
export const FETCH_ORDER_CONNECTED_MASTER_DETAIL = "FETCH_ORDER_CONNECTED_MASTER_DETAIL"
export const FETCH_SHIPMENT_CONNECTED_MASTER_ENTRIES = "FETCH_SHIPMENT_CONNECTED_MASTER_ENTRIES"
export const FETCH_ORDER_CONNECTED_MASTER_ENTRIES = "FETCH_ORDER_CONNECTED_MASTER_ENTRIES"

export const FETCH_SHIPMENT_TEMPLATE_HEADER = "FETCH_SHIPMENT_TEMPLATE_HEADER";
export const SAVE_ASN_ENTRY = "SAVE_ASN_ENTRY"
export const EDIT_ASN_ENTRY = "EDIT_ASN_ENTRY"
export const FETCH_ASN_DETAIL = "FETCH_ASN_DETAIL";


///dum
export const DUMMY_FETCH_TEMPLATE_LIST = "DUMMY_FETCH_TEMPLATE_LIST"
export const DUMMY_FETCH_TEMPLATE_DETAIL = "DUMMY_FETCH_TEMPLATE_DETAIL"

export const DUMMY_FETCH_INVENTORY_LIST = "DUMMY_FETCH_INVENTORY_LIST"
export const DUMMY_FETCH_INVENTORY_DETAIL = "DUMMY_FETCH_INVENTORY_DETAIL"

export const DUMMY_FETCH_SHIP_DETAIL = "DUMMY_FETCH_SHIP_DETAIL"

// UOM

export const FETCH_ALL_UOM = "FETCH_ALL_UOM";
export const ADD_UOM = "ADD_UOM";
export const CHANGE_USN_MODAL_STATUS = "CHANGE_USN_MODAL_STATUS";

//Super Admin
export const GENERATE_QR = "GENERATE_QR";
export const GENERATE_EXCEL ="GENERATE_EXCEl"
export const FETCH_ALL_COMPANY = "FETCH_ALL_COMPANY"
export const FETCH_COMPANY_DETAIL = "FETCH_COMPANY_DETAIL"
export const FETCH_COMPANY_STATUS_COUNT = "FETCH_COMPANY_STATUS_COUNT"
export const FETCH_COMPANY_TYPE_WISE_COUNT = "FETCH_COMPANY_TYPE_WISE_COUNT"
export const FETCH_SUPERADMIN_USERS_PERMISSIONS = "FETCH_SUPERADMIN_USERS_PERMISSIONS"
export const FETCH_SUPERADMIN_USERS_DETAIL = "FETCH_SUPERADMIN_USERS_DETAIL"

// Indentifier Configuration
export const GET_IDENTIFIER_SETTING = "GET_IDENTIFIER_SETTING"


// Label Configuration
export const FETCH_LABEL_CONFIGRATION = "FETCH_LABEL_CONFIGRATION"

export const CHECK_DISTINCT_MASTER_EXIST = "CHECK_DISTINCT_MASTER_EXIST"

export const GET_MAPPED_MASTER_IDS = "GET_MAPPED_MASTER_IDS"

export const FLUSH_MAPPED_IDS = "FLUSH_MAPPED_IDS"

// Area Mapping

export const GET_AREA_MAPPING_DATA = "GET_AREA_MAPPING_DATA"
export const GET_AREA_CATEGORY_OPTIONS = "GET_AREA_CATEGORY_OPTIONS"
export const FETCH_DOCK_MAPPING_DATA = "FETCH_DOCK_MAPPING_DATA"
export const FETCH_AREA_MAPPING_STATUS_COUNT = "FETCH_AREA_MAPPING_STATUS_COUNT"

export const GENERATE_JOB_DETAIL = "GENERATE_JOB_DETAIL"
export const GET_USERS_TO_ASSIGN_JOB = "GET_USERS_TO_ASSIGN_JOB"


//SUMMARY STOCK PAGE
export const FETCH_STOCK_SUMMARY_ACCESSIBILITY = "FETCH_STOCK_SUMMARY_ACCESSIBILITY"
export const FETCH_STOCK_SUMMARY_RFS = "FETCH_STOCK_SUMMARY_RFS"
export const FETCH_STOCK_SUMMARY_TOTALSTOCK = "FETCH_STOCK_SUMMARY_TOTALSTOCK"
export const FETCH_STOCK_SUMMARY_STOCKTYPES = "FETCH_STOCK_SUMMARY_STOCKTYPES"
export const FETCH_STOCK_SUMMARY_SKULIST = "FETCH_STOCK_SUMMARY_SKULIST"
export const FETCH_STOCK_SUMMARY_ALLOCATED_PICKED = "FETCH_STOCK_SUMMARY_ALLOCATED_PICKED"



//KIT

export const FETCH_KIT = "FETCH_KIT"
export const FETCH_KIT_STATUS_COUNT= "FETCH_KIT_STATUS_COUNT"
export const FETCH_KIT_DETAIL = "FETCH_KIT_DETAIL";
export const FETCH_CURRENT_KITTING_COUNT = "FETCH_CURRENT_KITTING_COUNT";
export const FETCH_KIT_DEKIT_CARDTYPEWISE_COUNT = "FETCH_KIT_DEKIT_CARDTYPEWISE_COUNT";

// DEKIT

export const FETCH_ALL_DEKIT = "FETCH_ALL_DEKIT"
export const FETCH_DEKIT_STATUS_COUNT= "FETCH_DEKIT_STATUS_COUNT"
export const FETCH_DEKIT_DETAIL= "FETCH_DEKIT_DETAIL"


// DYNAMIC PAGE CONFIG

export const FETCH_DYNAMIC_PAGE_CONFIG= "FETCH_DYNAMIC_PAGE_CONFIG"


//User
export const FETCH_USER_PRODUCTIVITY= "FETCH_USER_PRODUCTIVITY"
export const FETCH_USERS_TYPE_WISE_COUNT= "FETCH_USERS_TYPE_WISE_COUNT"
export const FETCH_ALL_CHECKPOINTS_PERMISSIONS= "FETCH_ALL_CHECKPOINTS_PERMISSIONS"


//Inventory Journey
export const FETCH_ITEM_DETAILS = "FETCH_ITEM_DETAILS"
export const FETCH_STOCK_UNIT_DATA = "FETCH_STOCK_UNIT_DATA"
export const FETCH_ASSOCIATED_JOB_DETAILS = "FETCH_ASSOCIATED_JOB_DETAILS"
export const FETCH_JOB_QTY_DATA = "FETCH_JOB_QTY_DATA"
export const FETCH_TRENDING_GRAPH_DATA = "FETCH_TRENDING_GRAPH_DATA"
export const FETCH_PROJECTION_DATA = "FETCH_PROJECTION_DATA"
export const FETCH_TRENDING_GRAPH_INSIGHTS = "FETCH_TRENDING_GRAPH_INSIGHTS"
export const FETCH_JOURNEY_MAP_DATA = "FETCH_JOURNEY_MAP_DATA"
export const FETCH_STOCK_CONFIGURATION_DATA = "FETCH_STOCK_CONFIGURATION_DATA"
export const FETCH_LOCATION_WISE_DATA = "FETCH_LOCATION_WISE_DATA"

//Monthly Transaction
export const FETCH_MONTHLY_TRANSACTION_DATA = "FETCH_MONTHLY_TRANSACTION_DATA"
export const FETCH_LOCATION_DATA_FOR_OPTIMIZER = "FETCH_LOCATION_DATA_FOR_OPTIMIZER"
export const FETCH_GRID_DATA_FOR_OPTIMIZER = "FETCH_GRID_DATA_FOR_OPTIMIZER"
export const FETCH_PUTAWAY_SOLVE_CUSTOM = "FETCH_PUTAWAY_SOLVE_CUSTOM"
export const FETCH_GRID_DATA_CONSTRAINTS_DATA = "FETCH_GRID_DATA_CONSTRAINTS_DATA"


//Automation Rules
export const FETCH_SKU_GROUP_DATA = "FETCH_SKU_GROUP_DATA"
export const FETCH_SKU_GROUP_DETAIL = "FETCH_SKU_GROUP_DETAIL"
export const FETCH_AUTOMATION_RULES_STATUS_COUNT = "FETCH_AUTOMATION_RULES_STATUS_COUNT"
export const FETCH_AUTOMATION_TABLE_DATA = "FETCH_AUTOMATION_TABLE_DATA"
export const FETCH_AUTOMATION_TASK_FIELDS = "FETCH_AUTOMATION_TASK_FIELDS"
export const FETCH_JOB_TYPES_BY_WORKFLOW = "FETCH_JOB_TYPES_BY_WORKFLOW"


// Workflow Management
export const FETCH_INWARD_WORKFLOW_LISTING = "FETCH_INWARD_WORKFLOW_LISTING"
export const FETCH_INHOUSE_WORKFLOW_LISTING = "FETCH_INHOUSE_WORKFLOW_LISTING"
export const FETCH_OUTWARD_WORKFLOW_LISTING = "FETCH_OUTWARD_WORKFLOW_LISTING"
export const FETCH_WORKFLOW_DETAILS = "FETCH_WORKFLOW_DETAILS"
export const FETCH_WORKFLOW_TYPEWISE_COUNT = "FETCH_WORKFLOW_TYPEWISE_COUNT"


//Custom Dashboard
export const FETCH_DRAGGABLE_WIDGETS = "FETCH_DRAGGABLE_WIDGETS"
export const FETCH_ALL_CUSTOM_DASHBOARD = "FETCH_ALL_CUSTOM_DASHBOARD"
export const FETCH_CUSTOM_DASHBOARD_DETAIL = "FETCH_CUSTOM_DASHBOARD_DETAIL"
export const FETCH_CUSTOM_DASHBOARD_STATUS_COUNT = "FETCH_CUSTOM_DASHBOARD_STATUS_COUNT"
export const FETCH_DEFAULT_DASHBOARD_DATA ="FETCH_DEFAULT_DASHBOARD_DATA"
export const FETCH_WAREHOUSE_COUNT_DATA = "FETCH_WAREHOUSE_COUNT_DATA"
export const FETCH_CUSTOM_DASHBOARD_JOB_STATUS_COUNT = "FETCH_CUSTOM_DASHBOARD_JOB_STATUS_COUNT"
export const FETCH_CUSTOM_DASHBOARD_WAREHOUSE_INVENTORY ="FETCH_CUSTOM_DASHBOARD_WAREHOUSE_INVENTORY"
export const GET_WAREHOUSE_OPRATION_COUNT_CUSTOM_DASHBOARD="GET_WAREHOUSE_OPRATION_COUNT_CUSTOM_DASHBOARD"
export const GET_WAREHOUSE_OPRATION_COUNT_CUSTOM_DASHBOARD_INSIGHTS="GET_WAREHOUSE_OPRATION_COUNT_CUSTOM_DASHBOARD_INSIGHTS"


//InHouse Palletization
export const FETCH_INHOUSE_PALLETIZATION_TABLE_DATA = "FETCH_INHOUSE_PALLETIZATION_TABLE_DATA"
export const FETCH_INHOUSE_PALLET_DETAIL = "FETCH_INHOUSE_PALLET_DETAIL"
export const FETCH_INHOUSE_PALLET_STATUS_COUNT = "FETCH_INHOUSE_PALLET_STATUS_COUNT"
export const FETCH_INHOUSE_PALLET_PICKING_READY = "FETCH_INHOUSE_PALLET_PICKING_READY"
export const FETCH_INHOUSE_PALLET_CARDTYPEWISE_COUNT = "FETCH_INHOUSE_PALLET_CARDTYPEWISE_COUNT"

// InHouse De-Palletization
export const FETCH_INHOUSE_DEPALLETIZATION_TABLE_DATA = "FETCH_INHOUSE_DEPALLETIZATION_TABLE_DATA"
export const FETCH_INHOUSE_DEPALLET_DETAIL = "FETCH_INHOUSE_DEPALLET_DETAIL"
export const FETCH_INHOUSE_DEPALLET_STATUS_COUNT = "FETCH_INHOUSE_DEPALLET_STATUS_COUNT"

//Quality Control
export const FETCH_QUALITYCHECK_CARD_COUNT = "FETCH_QUALITYCHECK_CARD_COUNT"
export const FETCH_RM_STOCK_TABLE_DATA = "FETCH_RM_STOCK_TABLE_DATA"
export const FETCH_RM_STOCK_DETAIL = "FETCH_RM_STOCK_DETAIL"
export const FETCH_RM_STOCK_STATUS_COUNT = "FETCH_RM_STOCK_STATUS_COUNT"
export const FETCH_HYGIENE_MATERIAL_CARDTYPEWISE_COUNT = "FETCH_HYGIENE_MATERIAL_CARDTYPEWISE_COUNT"
export const FETCH_SERRICO_MAPPED_DATA = "FETCH_SERRICO_MAPPED_DATA"
export const FETCH_HYGIENE_CONTROL_SUMMARY_DATA = "FETCH_HYGIENE_CONTROL_SUMMARY_DATA"
export const FETCH_FUMIGATION_SUMMARY_DATA = "FETCH_FUMIGATION_SUMMARY_DATA"
export const FETCH_RECEIPT_FUMIGATION_GRAPH__DATA = "FETCH_RECEIPT_FUMIGATION_GRAPH__DATA"
export const FETCH_TRAP_MONITORING_ZONE_RISK__DATA = "FETCH_TRAP_MONITORING_ZONE_RISK__DATA"
export const FETCH_TRAP_MONITORING_GRID_DATA = "FETCH_TRAP_MONITORING_GRID_DATA"
export const FETCH_FUMIGATION_SUMMARY_CARD_COUNT = "FETCH_FUMIGATION_SUMMARY_CARD_COUNT"
export const FETCH_PRE_SHIPMENT_INSPECTION_CARD_COUNT = "FETCH_PRE_SHIPMENT_INSPECTION_CARD_COUNT"
export const FETCH_HYGIENE_SUMMARY_CARD_COUNT = "FETCH_HYGIENE_SUMMARY_CARD_COUNT"


export const FETCH_STATUS_HISTORY_DATA = "FETCH_STATUS_HISTORY_DATA";
export const FETCH_STATUS_HISTORY_DETAIL = "FETCH_STATUS_HISTORY_DETAIL";

// Tour
export const FETCH_MODULE_WISE_TOUR_STEPS = "FETCH_MODULE_WISE_TOUR_STEPS"

// Area Summary Page
export const FETCH_AREA_SUMMARY_GRID_TYPE_WISE_COUNT = "FETCH_AREA_SUMMARY_GRID_TYPE_WISE_COUNT"
export const FETCH_AREA_SUMMARY_TYPE_WISE_LOCATION_UTILIZATION = "FETCH_AREA_SUMMARY_TYPE_WISE_LOCATION_UTILIZATION"
export const FETCH_AREA_SUMMARY_LOCATIONS_BY_UTILIZATION_BUCKET = "FETCH_AREA_SUMMARY_LOCATIONS_BY_UTILIZATION_BUCKET"
export const FETCH_AREA_SUMMARY_SKU_STOCKS = "FETCH_AREA_SUMMARY_SKU_STOCKS"
export const FETCH_AREA_SUMMARY_SKU_LOCATION_DETAIL = "FETCH_AREA_SUMMARY_SKU_LOCATION_DETAIL"
